
webpack.register(
    'modules/player-bio/player-bio',
    function() {
        return import('modules/player-bio/player-bio');
    },
    true
);